import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

function useCalendar({ from, to } = {}) {
  return useQuery({
    queryKey: ["student", "calendar", from, to],
    queryFn: async () => {
      const params = {};
      if (from) params.from = from;
      if (to) params.to = to;
      const res = await apiClient.get("/api/v1/calendar/", { params });
      return res.data;
    },
  });
}

export { useCalendar };
